import { Navigate } from "react-router-dom";
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
// import Chatbot from "./components/Chatbot"; // import Chatbot if needed globally
import Footer from "./components/Footer";

function App() {
  const [userID, setUserID] = useState("N/A");
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <div className="App">
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Login setUserID={setUserID} />}/>
          {/* <Route
            path="/dashboard"
            element={
              <Dashboard
                userID={userID}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
            }
          /> */}
          <Route
            path="/dashboard"
            element={
              userID ? (
                <Dashboard
                  userID={userID}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
        {/* <Chatbot userID={userID} selectedDate={selectedDate} /> */}
        <Footer />
      </Router>
    </div>
  );
}

export default App;
